import IssuersCell from './IssuersCell';

export default IssuersCell;
